<template>
  <TTabsToggle
    :header="$t('forms.settings_element_image')"
    no-move
    :changed="wasChanged"
    data-testid="image-settings"
  >
    <menu-content-container border-full>
      <TLabel
        :changed="align.changed"
        :tooltip="$t('forms.reset_value')"
        @reset="align.reset"
        >{{ $t("forms.image_align") }}</TLabel
      >
      <content-row justify-between>
        <TButtonGroup>
          <TGroupButton
            data="left"
            small
            data-testid="align-left"
            :active="align.model === 'left'"
            @button-clicked="align.model = 'left'"
          >
            <AligmentLeft />
          </TGroupButton>
          <TGroupButton
            data="center"
            small
            data-testid="align-center"
            :active="align.model === 'center'"
            @button-clicked="align.model = 'center'"
          >
            <AligmentCenter />
          </TGroupButton>
          <TGroupButton
            data="right"
            small
            data-testid="align-right"
            :active="align.model === 'right'"
            @button-clicked="align.model = 'right'"
          >
            <AligmentRight />
          </TGroupButton>
        </TButtonGroup>

        <t-switch
          v-model="fluidOnMobile.model"
          data-testid="fluid-on-mobile"
          :label="$t('forms.fluid_on_mobile')"
          :changed="fluidOnMobile.changed"
          @reset="fluidOnMobile.reset"
        ></t-switch>
      </content-row>
    </menu-content-container>

    <borderRadiusForm
      data-testid="image-border-radius"
      :label="$t('forms.border_radius')"
      external-usage
      :external-border-radius="borderRadius.model"
      :changed="borderRadius.changed"
      :default-value="borderRadius.defaultValue"
      @borderRadiusChanged="borderRadius.model = $event"
      @reset="borderRadius.reset"
    ></borderRadiusForm>

    <padding-form
      external-usage
      :external-padding="padding.model"
      :label="$t('forms.image_margin')"
      data-testid="image-margin"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      @padding-changed="padding.model = $event"
      @reset="padding.reset"
    />
  </TTabsToggle>
</template>

<script setup lang="ts">
  import paddingForm from "@/forms/paddingForm.vue";
  import borderRadiusForm from "@/forms/borderRadiusForm.vue";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { AligmentLeft, AligmentCenter, AligmentRight } from "@topol/icons";
  import {
    TTabsToggle,
    TSwitch,
    TLabel,
    TButtonGroup,
    TGroupButton,
  } from "@topol/twig-ui";

  const { str, bool, nullable, anyChanged } = useBlockAttr({
    mode: "global",
    block: "mj-image",
  });

  const align = str("align", "center");
  const fluidOnMobile = bool("fluid-on-mobile", "true", "false");
  const borderRadius = nullable("border-radius");
  const padding = nullable("padding");

  const wasChanged = anyChanged(align, fluidOnMobile, borderRadius, padding);
</script>
